module.exports = __webpack_public_path__ + "img/nft-demographic.png";